<template>
    <div class="container"  v-title="'隐私政策'">
        <Navigation-bar id="navigation_bar" type="dark"></Navigation-bar>
        <div class="container_content">
            <div class="title">
                <h2>隐私政策</h2>
                <YD-image class="logo" src="logo_新"></YD-image>
                <p class="subTitle">亿动体育用户隐私政策</p>
            </div>
            <div id="PrivacyAgreement">
                <div class="PrivacyAgreement_content" v-html="contentHtml">
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { get } from '@/api/htmlRequest'
export default {
    name: 'PrivacyAgreement',
    data() {
        return {
            contentHtml: ''
        }
    },
    created(){
        get(process.env.VUE_APP_PUBLIC_URL + '/html/隐私政策/index.html').then(data=>{
            this.contentHtml = data;
        })
    }
};
</script>
<style lang="scss" scoped>
.title{
    height: 198px;
    padding: 24px 40px 0;
    box-sizing: border-box;
    background: #1B1C1E;
    position: relative;
    h2{
        @include line-height(84px);
        font-size: 60px;
        color: #FFFFFF;
        font-weight: 500;
    }
    .logo{
        width: 106px;
        height: 56px;
        position:absolute;
        right: 40px;
        top: 38px;
    }
    p{
        @include line-height(44px);
        font-size: 32px;
        color: #43C8D9;
        font-weight: 400;
        margin-top: 6px;
    }
}
#PrivacyAgreement{
    .PrivacyAgreement_content{
        padding: 40px;
        box-sizing: border-box;
    }
}
</style>
<style lang="scss">
.PrivacyAgreement_content{
    p{
        min-height: 28px;
        font-size: 28px;
        color: #4D5561;
        text-align: justify;
        line-height: 44px;
        font-weight: 400;
        b{
            list-style: none;
            font-size: 28px;
            color: #1B1C1E;
            text-align: justify;
            line-height: 44px;
            font-weight: 600;
        }
    }
    p[t1]{
        color: #1B1C1E;
        font-weight: 600;
        font-size: 38px;
        line-height: 52px;
        margin-bottom: 16px;
    }
    p[t2]{
        color: #1B1C1E;
        font-weight: 600;
        font-size: 32px;
        margin-bottom: 40px;
        margin-left: -18px;
    }
    p[t3]{
        color: #1B1C1E;
        font-weight: 600;
        font-size: 30px;
        margin-bottom: 24px;
        margin-top: 40px;
    }
    .t3_List{
        padding: 32px 0 16px;
        [t3]{
            margin-bottom: 16px;
            margin-top: 0;
        }
    }
    p[t4]{
        color: #1B1C1E;
        font-weight: 600;
        margin-bottom: 16px;
        margin-top: 24px;
    }
    p[t3] + p[t4]{
        margin-top: 0;
    } 
    ol{
        padding-top: 32px;
        li{
            font-size: 28px;
            color: #1B1C1E;
            font-weight: 600;
            padding-left: 48px;
            box-sizing: border-box;
            margin-bottom: 16px;
            position: relative;
            &::before{
                content: '';
                width: 32px;
                height: 32px;
                background: #1B1C1E;
                border-radius: 50%;
                display: block;
                position: absolute;
                top: 3px;
                left: 0;
            }
        }
    }
}  
</style>